import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";
import { batch } from "react-redux";
import { BannersAdminState } from "./types";
import { setResponseMessage } from "../adminSlice";
import userStorage from "store/UserStorage";

const initialState: BannersAdminState = {
  banners: [],
  bannersWithImages: [],
  options: undefined,
  loading: false,
};

const bannersAdmin = createSlice({
  name: "bannersAdminSlice",
  initialState,
  reducers: {
    setBanners(state, action) {
      state.banners = action.payload;
    },
    setBannersWithImages(state, action) {
      state.bannersWithImages = action.payload;
    },
    setBannerOptions(state, action) {
      state.options = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
});
export const {
  setLoading,
  setBanners,
  setBannerOptions,
  setBannersWithImages,
} = bannersAdmin.actions;
export const selectLoading = (state: RootState) => state.bannersAdmin.loading;
export const selectBannerOptions = (state: RootState) =>
  state.bannersAdmin.options;

export const selectAllBanners = (state: RootState) =>
  state.bannersAdmin.banners;

export const selectBannersWithImages = (state: RootState) =>
  state.bannersAdmin.bannersWithImages;

export const fetchAllBanners = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const result = await axios.get(`${API_URL}/admin/banners`);
    batch(() => {
      console.log(result.data.data);
      dispatch(setBanners(result.data.data));
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(setLoading(false));
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const fetchBannersWithImages = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const result = await axios.get(`${API_URL}/banners`);
    batch(() => {
      dispatch(setBannersWithImages(result.data.data));
      dispatch(setLoading(false));
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const fetchBannerOptions = (id: string) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const result = await axios.get(`${API_URL}/admin/banner-values/${id}`);
    batch(() => {
      dispatch(setBannerOptions(result.data.data));
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(setLoading(false));
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const addBanner = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    const banner: { title: string; link: string; is_active: boolean } = {
      title: data.title,
      link: data.link,
      is_active: data.is_active,
    };
    dispatch(setLoading(true));
    let formData = new FormData();
    formData.append("file", data.image.file);
    formData.append("banner", JSON.stringify(banner));

    let token = userStorage.getUser();
    const response = await axios.post(`${API_URL}/admin/banners`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
    dispatch(
      setResponseMessage({
        message: "Успешно качихте банера.",
        hasError: false,
      })
    );
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export const updateBanner = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    let formData = new FormData();
    formData.append("banner", JSON.stringify(data.data));
    formData.append("file", data.data.image);
    let token = userStorage.getUser();
    const response = await axios.put(
      `${API_URL}/admin/banners/${data.id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
      }
    );
    dispatch(
      setResponseMessage({
        message: "Успешно променихте банера.",
        hasError: false,
      })
    );
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    //  console.log(`Error in addProduct: ${error.message}`);
  }
};

export const deleteBanner = (id: string) => async (dispatch: any) => {
  try {
    let token = userStorage.getUser();
    const response = await axios.delete(`${API_URL}/admin/banners/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно изтрихте банера.",
          hasError: false,
        })
      );
      dispatch(fetchAllBanners());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    //  console.log(`Error in deleteProduct: ${error.message}`);
  }
};

export default bannersAdmin.reducer;
